<template>
  <span>
    <i class="fa fa-clock-o" aria-hidden="true"></i>
    {{timeFormatted}}
  </span>
</template>

<script>
import moment from "moment";

export default {
  name: "TimeRemaining",
  props: {
    remainingSeconds: Number
  },
  data() {
    return {};
  },
  computed: {
    timeFormatted() {
      let tempTime = moment.duration(this.remainingSeconds, "seconds");
      let minutes = parseInt(tempTime.minutes());
      let hours = parseInt(tempTime.hours());

      let s = `${hours} hr. ${minutes} min. left`;

      if (hours <= 0) {
        s = `${minutes} min. left`;
      }

      if (minutes <= 2 && hours == 0) {
        s = "Finishing...";
      }

      return s;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/machine/TimeRemaining.vue